module.exports = __webpack_public_path__ + "static/media/truck-classic-3.1abec561.jpg";